/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ClearanceCaseRowSummaryDeclarationDto } from './clearance-case-row-summary-declaration-dto';
import { ClearanceCaseRowTaxDto } from './clearance-case-row-tax-dto';
import { ClearanceCaseRowAttachedDocumentDto } from './clearance-case-row-attached-document-dto';
import { ClearanceCaseRowSpecificInformationDto } from './clearance-case-row-specific-information-dto';
import { ClearanceCaseRowDataSourceDto } from './clearance-case-row-data-source-dto';
import { ClearanceCaseDocumentDto } from './clearance-case-document-dto';
import { ClearanceCaseAuthorisationDto } from './clearance-case-authorisation-dto';
import { ClearanceCaseAdditionDeductionDto } from './clearance-case-addition-deduction-dto';

//<custom-head>
import { ArticleDto } from './article-dto';
//</custom-head>

export class ClearanceCaseRowDataDto {
  public id: number = undefined;
  public index: number = undefined;
  public articleId: string = undefined;
  public articleNumber: string = undefined;
  public statnrSe: string = undefined;
  public statnrNo: string = undefined;
  public additionalCode1: string = undefined;
  public additionalCode2: string = undefined;
  public additionalCode3: string = undefined;
  public reducedTaxNo: boolean;
  public chassisNumber: string = undefined;
  public goodsMarking: string = undefined;
  public packageCount: number = undefined;
  public packageCategoryCode: string = undefined;
  public description: string = undefined;
  public originCountryCode: string = undefined;
  /**
   * Avsändning fylke, only used for norwegian exports
   */
  public originCountyId: number = undefined;
  public grossWeight: number = undefined;
  public sePreferenceCode: string = undefined;
  public noPreferenceCode: string = undefined;
  public cUSCode: string = undefined;
  public netWeight: number = undefined;
  public afsStatus: boolean;
  public vatCode: number = undefined;
  public euGoods: boolean;
  public freightExchangeRate: number = undefined;
  public textileLicenseAmount: number = undefined;
  public textileLicenseNumber: string = undefined;
  public quotas: string = undefined;
  public summaryDeclarations: ClearanceCaseRowSummaryDeclarationDto[];
  public taxes: ClearanceCaseRowTaxDto[];
  public attachedDocuments: ClearanceCaseRowAttachedDocumentDto[];
  public specificInformation: ClearanceCaseRowSpecificInformationDto[];
  public sources: ClearanceCaseRowDataSourceDto[];
  public forceOtherQuantity: boolean;
  public forceOtherQuantityNo: boolean;
  /**
   * Shows unit from Statnr by default
   */
  public otherQuantityId: number = undefined;
  public otherQuantityUnitNo: string = undefined;
  public otherQuantity: number = undefined;
  public otherQuantityNo: number = undefined;
  public price: number = undefined;
  public valueDeterminationNo: string = undefined;
  public valueDeterminationSe: string = undefined;
  public importProcedureId: number = undefined;
  public exportProcedureId: number = undefined;
  public importProcedureAddonCode: string = undefined;
  public exportProcedureAddonCode: string = undefined;
  public adjustment: number = undefined;
  public statisticalValue: number = undefined;
  public customsWarehouseCode: string = undefined;
  public customsWarehouseType: string = undefined;
  public customsWarehouseCountry: string = undefined;
  public sellerId: string = undefined;
  public buyerId: string = undefined;
  public declarantId: string = undefined;
  public delegateId: string = undefined;
  public exporterId: string = undefined;
  public importerId: string = undefined;
  public consolidatorId: string = undefined;
  public shipperId: string = undefined;
  public manufacturerId: string = undefined;
  public warehouseOwnerId: string = undefined;
  public guaranteeId: string = undefined;
  public customsPayerId: string = undefined;
  public valuationIndicators: string = undefined;
  public earlierDocuments: ClearanceCaseDocumentDto[];
  public additionalInformationDocuments: ClearanceCaseDocumentDto[];
  public additionalReferenceInformationDocuments: ClearanceCaseDocumentDto[];
  public transportDocuments: ClearanceCaseDocumentDto[];
  public supportingDocuments: ClearanceCaseDocumentDto[];
  public authorisations: ClearanceCaseAuthorisationDto[];
  public additionDeductions: ClearanceCaseAdditionDeductionDto[];
  public addons: ClearanceCaseDocumentDto[];

  //<custom-body>
  public fromArticle(article: ArticleDto, index: number): ClearanceCaseRowDataDto {
    this.index = index;
    this.articleId = article.id;
    this.articleNumber = article.articleNumber;
    this.statnrSe = article.statnrSe;
    this.statnrNo = article.statnrNo;
    this.additionalCode1 = article.additionalCode1;
    this.additionalCode2 = article.additionalCode2;
    this.additionalCode3 = article.additionalCode3;
    this.originCountryCode = article.originCountryCode;
    this.attachedDocuments = article.attachedDocuments.map(ad => ClearanceCaseRowAttachedDocumentDto.fromArticle(ad));
    this.specificInformation = article.specificInformation.map(si => new ClearanceCaseRowSpecificInformationDto().fromArticle(si));
    this.taxes = article.taxes.map(t => new ClearanceCaseRowTaxDto().fromArticle(t));

    return this;
  }
  //</custom-body>
}
